module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageTitle":"Home","hello":"Hi!","message":"This is my portfolio and CV. You visit different pages via either header or footer."},"fi":{"pageTitle":"Home","hello":"Terve!","message":"Tämä sivu on portfolioni / CV:ni. Ylä- ja alapalkeista voit vierailla eri sivuilla."}}')
  delete Component.options._Ctor
}
